// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/line-table.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customer Dashboard */
.main {
  /* padding-top: 20px; */
  padding-bottom: 20px;
  /* margin-bottom: 60px; */
}
.chart #myChart,
.main-content {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
}
.main-content {
  margin-top: 20px;
  margin-bottom: 20px;
  min-height: 65vh;
}
.main-title-wrapper {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 34px;
}
.main-title-wrapper h2 {
  margin-bottom: 0;
}
.main-title-wrapper .primary-default-btn svg {
  margin-right: 9px;
}
.main-btns-wrapper,
.main-title-wrapper,
.users-item {
  display: flex;
}
.main-btns-wrapper {
  align-items: center;
  flex-wrap: wrap;
}
.main-btns-wrapper button {
  margin-right: 10px;
}

.users .col-xl-3 {
  margin-bottom: 20px;
}
.users-item {
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 10px;
  background-color: #fff;
  text-align: center;
}
.users-item a:focus {
  outline: 0;
}
.users-item-body {
  padding: 20px 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.users-item__img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 10px;
}
.users-item__name {
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  color: #171717;
}
.users-item__desc,
.users-item__role {
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  color: #767676;
}
.users-item__desc {
  max-width: 231px;
  font-size: 12px;
  margin-bottom: 15px;
}
.users-item__more {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0.5;
}
.users-item-dropdown {
  right: 20px;
  top: 60px;
  width: 125px;
}
.users-item-dropdown.active {
  opacity: 1;
  visibility: visible;
}
.users-item .primary-white-btn {
  border-top: 1px solid #eee;
  width: 100%;
}
.footer {
  border-top: 1px solid #e0e1ea;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #b9b9b9;
  font-size: 12px;
}
.footer--flex {
  justify-content: space-between;
}
.footer a,
.footer-start p {
  font-weight: 500;
  line-height: 2.83;
}
.footer--flex,
.footer-end {
  display: flex;
  align-items: center;
}
.footer a {
  border-bottom: 1px transparent dashed;
}
.footer a:hover {
  color: #2f49d1;
  border-color: #2f49d1;
}

.card_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}
.admin_dashboard h4 {
  color: #163873;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.dash_user_sec {
  display: flex;
  gap: 15px;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}
.card_single {
  max-width: 280px;
  width: 100%;
  height: 152px;
  justify-content: center;
  padding: 20px;
  border-radius: 16px !important;
  background: #fff;
  border: none !important;

}
.icon_sec {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon_sec p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin: auto;
  line-height: normal;
}
.card_block h3 {
  color: var(--Black, #010404);
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: 0px;
  line-height: normal;
  letter-spacing: 0.25px;
}
.card_pic {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
}
.card_pic img {
  max-width: 115px;
  width: 100%;
  min-height: 50px;
}
.card_pic p {
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: right;
}
.card_pic p span {
  color: #38b000;
  font-weight: 700;
}
.inner_banner_dash.my-3 {
  min-height: 269px;
  background: #ebebeb;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.inner_banner_dash p,
.inner_side_banner p {
  color: #b7b7b7;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.inner_side_banner {
  width: 100%;
  min-height: 714px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.text-h6 {
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: #010404;

}

.drop-down-text {
  color: #5c677d;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.4px;
}
.drop-down-text :hover :focus {
  border-color: #5c677d;
}
.dash_graph {
  background-color: #fff;
  padding: 30px;
}
.th-text{
 color: #010404 !important;
}
/* --------------------------------------------- */
/* ---- Super Admin: Inner Pages Data Tabel ---- */
/* -------------------------------------------- */

.tabel_page .card {
  border-radius: 20px;
  background: #fff;
  padding: 15px;
}

.search_table {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.search_table .form-control {
  border-radius: 10px !important;
  border: 1px solid #e5e6e7 !important;
  background: #fff;
  padding-left: 35px;
  max-width: 270px;
  width: 100%;
  min-height: 40px;
  color: #b8b8b8;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.search_table svg {
  position: absolute;
  left: 10px;
}
.btn_invite {
  display: flex;
  width: 100%;
  max-width: 105px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #163873;
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.btns_sec {
  display: flex;
  gap: 10px;
  align-items: center;
}

.btns_sec label {
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  min-width: 50px;
}

select.form-select {
  padding: 7px;
  border-radius: 10px;
  border: 1px solid var(--Stroke, #e5e6e7);
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  min-height: 40px;
}

.filter_input span {
  position: absolute;
  right: 10px;
  top: 10px;
}
.filter_input .form-control {
  border-radius: 10px;
  border: 1px solid var(--Stroke, #e9ecef) !important;
  background: var(--White, #fff);
}
.filter_btns_grp {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
}
.select__box_block .form-select {
  border-radius: 10px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: var(--White, #fff);
  min-height: 40px;
  padding: 10px;
}

.btn_online {
  border-radius: 30px;
  background: rgba(56, 176, 0, 0.1);
  width: 67px;
  height: 20px;
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.table_block .page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #163873;
  border-color: #163873;
}
.table_block .page-link {
  color: #163873;
}
table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0px !important;
  border-left-width: 0;
  border-right-width: 0;
}
#dataTable_wrapper td {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-align: left;
}
#dataTable_wrapper .table thead th {
  vertical-align: bottom;
  border-bottom: none;
  border-right: 1px solid #dfdfdf;
  border-top: none;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
#dataTable_wrapper .table thead th:last-child {
  border-right: none !important;
}
.table_block .even {
  background: transparent;
}
.table_input_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}
#dataTable_wrapper .dropdown-item {
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  color: var(--Black, #010404);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  gap: 10px;
}

.table_top_sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table_handle {
  display: flex;
  align-items: center;
  gap: 10px;
}
.btn_add_table {
  background: #163873;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #ffffff;
  border: none;
  padding: 10px 5px;
  width: 100%;
}
.btn_add_table span {
  float: left;
  margin-left: 10px;
}

.item_search {
  padding-left: 30px !important;
}
.search_icon {
  position: absolute;
  left: 10px;
  top: 10px;
}
.btn_fillters {
  border: 1px solid #c4c4c4 !important;
  border-radius: 6px;
}
.table_block .dataTables_wrapper div.dataTables_filter {
  display: none;
}
#dataTable {
  text-align: center;
}
.table td,
.table th {
  vertical-align: baseline;
}
.table_block #dataTable_length {
  display: none;
}
tr.table_heading {
  background: #163873;
  border: 1px solid #c4c4c4;
  color: #fff;
}
.table_heading th {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 1px;
  color: #ffffff;
}
.even {
  background: #f5fafc;
}
.btn_boost {
  display: flex;
  width: 80px;
  height: 30px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 6px;
  background: var(--Primary, #163873);
  color: var(--White, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
td.verified {
  color: #38b000 !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
td.unverified {
  color: #ff2525 !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
button.btn_offline {
  width: 67px;
  height: 20px;
  border-radius: 30px;
  background: rgba(128, 130, 130, 0.1);
  color: #808282;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.btn_report {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;
  color: #fd0d0d;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  border-radius: 30px;
  background: rgba(253, 13, 13, 0.1);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
}
.btn_report_priority{
  font-size: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;
  color: #fd0d0d;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  border-radius: 30px;
  background: rgba(253, 13, 13, 0.1);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
}
.btn_pending_customer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(255, 122, 0, 0.1);
  color: #ff7a00;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}

.btn_accept_customer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;
  border-radius: 30px;
  background: #38b0001a;
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.btn_accept_customer_add{
  font-size: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;
  border-radius: 30px;
  background: #38b0001a;
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.btn_reject_customer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: #fd0d0d1a;
  color: #fd0d0d;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.btn_approved {
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(56, 176, 0, 0.1);
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.btn_reserved {
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(253, 13, 13, 0.1);
  color: #fd0d0d;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.table_tab_sec .nav-pills {
  display: flex;
  gap: 15px;
}
.table_tab_sec .nav-pills .nav-link {
  border-radius: 0.25rem;
  background: transparent;
  color: var(--Gray-1, #808282);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.table_tab_sec .nav-pills .nav-link.active {
  color: #163873;
  border-bottom: 1px solid #163873;
}
.table_tab_sec h3 {
  color: #163873;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 14px;
}

.btn-generate {
  border: none;
  display: flex;
  width: 100%;
  min-width: 123px !important;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #163873;
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.btn_export {
  display: flex;
  min-width: 123px !important;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid var(--Primary, #163873);
  background: var(--Base, #fafafa);
  color: var(--Primary, #163873);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.menu-dropdown {
  min-width: 204px !important;
  box-shadow: 0px 8px 18px 0px #0000001a !important;
  border-radius: 10px !important;
  border: none !important;
}

/* Profile */
.profile__tab .nav-pills a {
  display: flex;
  max-width: 200px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
  align-items: center;
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.profile__tab .nav-pills .active {
  color: #163873;
  border-radius: 8px;
  background: rgba(22, 56, 115, 0.1);
}
.profile__content {
  max-width: 500px;
  width: 100%;
  padding: 0px 50px;
}
.profile__content .btn-primary {
  border-radius: 10px;
  background: #163873;
  border: 1px solid #163873;
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  min-height: 50px;
}
.pic_upload {
  margin: 20px 0px;
}
.profile__content .form-group .form-control {
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: #e9ecef;
  min-height: 50px;
}
.profile__content_label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.profile_content_inputfield {
  border: 1px solid #e9ecef;
  background: linear-gradient(0deg, #e9ecef, #e9ecef),
    linear-gradient(0deg, #e9ecef, #e9ecef);
  border-radius: 12px !important;
  height: 50px;
  min-width: 400px;
  color: #010404 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19.2px !important;
}

.nav-link-profile.active {
  border-radius: 8px;
  height: 40px;
  background: #1638731a;
  color: #163873 !important;
  font-size: 16px !important;
  font-weight: 700;
}

.false.nav-link {
  color: #5c677d !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19.2px !important;
}

.td-items {
  cursor: pointer;
}

.nav-item {
  margin-bottom: 1rem;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.dropdown-notification {
  width: 100%;
  min-width: 200px;
  top: 0;
  left: -20px !important;
  transform: translate(-50%, 10%);
}

a.dropdown-menu-header.dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 5px;
  padding: 5px;
}
/* fix QA bugs manage  dimention of  dropdown-menu.show */
.dropdown-menu.show {
  /* width: 100%; */
  /* min-width: 200px; */
  top: 0;
  left: 0;
  transform: translate(-60%, 10%);
  min-height:40px !important;
  min-width: 86px !important;
}


/* Facility panal */
.date_facility {
  width: 100%;
  max-width: 84px;
  min-height: 40px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 10px;
  border: 1px solid rgba(233, 236, 239, 1)
}


.btns_sec .form-select{
  min-width: 150px;
}

/* new css work order request */
.property_wrap {
  border-radius: 30px;
  background: #fff;
  width: 100%;
  padding: 50px;
}

.heading_add {
  display: flex;
  justify-content: end;
}

.request_order {
  max-width: unset !important;
  margin: auto;
  text-align: center;
  justify-content: center;
}

.heading_content {
  max-width: 750px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.heading_content h3 {
  color: var(--Black, #010404);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.work__order__request_wrap ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.work__order__request_wrap ul li {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.img-click {
  cursor: pointer;
}

.work_order_list {
  max-width: 300px;
  width: 100%;
  border-bottom: 20px;
  padding: 10px;
}

.work_order_list .form-label {
  color: var(--grayscale-light-text-2, #acaebe);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.work_order_list .form-control {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
  border: none;
}


.work_order_list input:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  
}
.btn_order {
  gap: 10px;
}
.modal_delete_btn {
  color: #fd0d0d;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.8px;
  width: 120px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #fd0d0d;
}

.btn_order .btn-primary {
  display: flex;
  width: 120px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: #163873;
  border: 1px solid #163873;
}

/* forgot password */
.forgot-pass-div {
  width: 100%;
  max-width: 720px;
  margin: auto;
  justify-content: center;
  text-align: center;
  padding: 150px 0px;
}

.forgot-p {
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
  color: #010404;
}

.forgot-para {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color:  #808282;
}

.btn-width {
  max-width: 400px !important;
}

.form-control-forgot {
  max-width: 400px;
  height: 50px !important;
  border-radius: 12px !important;
  margin: auto;
  color:  #5C677D !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
}

.back-div{
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.005em;
  text-align: left;
  color: #000000;
}

.owner_input {
  max-width: 400px;
  width: 100%;
  margin: auto;
}

.owner_input .form-control {
  padding: 0px 45px;
}

.owner_input span {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(30%, 40%);
}

.show-password {
  position: absolute;
  opacity: 0.7;
  right: 0px;
  top: 0px;
  transform: translate(-15px, 20px);
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.upload_sec_order {
  display: flex;
  gap: 20px;
}

.btn-close-order {
  min-width: 146px;
} 
 /* add css for facility panel */
 .placeholder_text::placeholder {
  color:  #010404 !important;
}
.date-picker-container {
    display: flex;
    align-items: center;
}
.date-picker-icon{
  position: relative;
  right: 21px;
}

/* New QA bug css added */
.customer_dropdown_tabal  {
  width: 104px ;
  box-shadow: 0px 8px 18px 0px #0000001A !important;
  border: none !important;
  border-radius: 10px !important;
  min-height:120px
}

.border-th {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  margin-bottom: 10px !important;
}

th {
  color:  #010404 !important;
}

td {
  color: #010404 !important;
  font-weight: 500 !important;
  font-size: 16px !important;
}

.text-colors {
  color: #010404;
}

.img-pin {
  width: 17px;
  height: 17px;
}

.btns_sec_tabel {
  min-width: 150px !important;
}

.text_red {
  color: #FD0D0D !important;
}

.right_msg_width {
  width: 100%;
  max-width: 500px;
}
.update-upload{
  color:#010404 !important;
}
.going{
  font-size: 16px !important;
}
/* //add new css for customer panel */
.date_facility_w {
  color: #010404 !important;
  width: 100%;
  max-width: 84px;
  min-height: 40px;
  border-radius: 10px !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 10px;
  border:1px solid var(--Stroke, #e5e6e7) !important;
}
.calender_c {
  display: flex;
  flex-direction: row;
  margin-bottom: 5px; 
}
.active_header {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 5px; 
}
/* add some css make for responsive seema*/
.facility_dash {
  display: flex;
  gap: 0.5rem; 
}

.btn_order_a {
  display: flex;
  justify-content: center;
  padding-top: 3rem; 
  padding-bottom: 3rem; 
}
@media only screen and (min-width: 310px) and (max-width: 425px) {
.btn_order_a{
  flex-direction: column !important;
}.modal_delete_btn_f {
  width:100% !important;
}.btn_order .btn-primary {
  width:100% !important;
}
}

.modal_delete_btn_f{
  color: #fd0d0d;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.8px;
  width: 120px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #fd0d0d;
}
/* new css work order request */

@media only screen and (min-width: 310px) and (max-width: 768px) {
  .property_wrap {
    padding: 0px;
  }.main-nav{
    padding-bottom: 40px !important;
  }
}
.modal_delete_btn_ff {
  color: #fd0d0d;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.8px;
  width: 120px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #fd0d0d;
  background:transparent !important;
}
.modal_cancel_btn_f {
  display: flex;
  width: 160px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  background: #163873;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
.white{
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/customerpenal/styles/customer-common.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EAGE,8BAA8B;EAG9B,mBAAmB;EAEnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAKE,aAAa;AACf;AACA;EAGE,mBAAmB;EAEnB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAIlB,sBAAsB;EAGtB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EAGpB,aAAa;EAIb,sBAAsB;EAGtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;AACd;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EAGE,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAIE,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;;AAEzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;CACC,yBAAyB;AAC1B;AACA,kDAAkD;AAClD,kDAAkD;AAClD,iDAAiD;;AAEjD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mCAAmC;EACnC,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB;2CACyC;EACzC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,YAAY;AACd;AACA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;AAC5B;;;AAGA,mBAAmB;AACnB;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;;AAGA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;;AAE7B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;CACC,+BAA+B;CAC/B;EACC,0BAA0B;AAC5B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,iDAAiD;EACjD,uBAAuB;EACvB,8BAA8B;EAC9B;AACF;;AAEA;EACE,yDAAuD;EACvD,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,0CAA0C;AAC1C;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;AACA;EACE,iCAAiC;AACnC,CAAC;EACC,qBAAqB;AACvB,CAAC;EACC,qBAAqB;AACvB;AACA;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,+BAA+B;;AAE/B;EACE;IACE,YAAY;EACd,CAAC;IACC,+BAA+B;EACjC;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":["/* Customer Dashboard */\n.main {\n  /* padding-top: 20px; */\n  padding-bottom: 20px;\n  /* margin-bottom: 60px; */\n}\n.chart #myChart,\n.main-content {\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 20px;\n}\n.main-content {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  min-height: 65vh;\n}\n.main-title-wrapper {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-bottom: 34px;\n}\n.main-title-wrapper h2 {\n  margin-bottom: 0;\n}\n.main-title-wrapper .primary-default-btn svg {\n  margin-right: 9px;\n}\n.main-btns-wrapper,\n.main-title-wrapper,\n.users-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.main-btns-wrapper {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.main-btns-wrapper button {\n  margin-right: 10px;\n}\n\n.users .col-xl-3 {\n  margin-bottom: 20px;\n}\n.users-item {\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  height: 100%;\n  border-radius: 10px;\n  background-color: #fff;\n  text-align: center;\n}\n.users-item a:focus {\n  outline: 0;\n}\n.users-item-body {\n  padding: 20px 20px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.users-item__img {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.users-item__name {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.4;\n  letter-spacing: -0.3px;\n  color: #171717;\n}\n.users-item__desc,\n.users-item__role {\n  font-size: 14px;\n  line-height: 1.4;\n  letter-spacing: -0.3px;\n  color: #767676;\n}\n.users-item__desc {\n  max-width: 231px;\n  font-size: 12px;\n  margin-bottom: 15px;\n}\n.users-item__more {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  opacity: 0.5;\n}\n.users-item-dropdown {\n  right: 20px;\n  top: 60px;\n  width: 125px;\n}\n.users-item-dropdown.active {\n  opacity: 1;\n  visibility: visible;\n}\n.users-item .primary-white-btn {\n  border-top: 1px solid #eee;\n  width: 100%;\n}\n.footer {\n  border-top: 1px solid #e0e1ea;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  color: #b9b9b9;\n  font-size: 12px;\n}\n.footer--flex {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.footer a,\n.footer-start p {\n  font-weight: 500;\n  line-height: 2.83;\n}\n.footer--flex,\n.footer-end {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.footer a {\n  border-bottom: 1px transparent dashed;\n}\n.footer a:hover {\n  color: #2f49d1;\n  border-color: #2f49d1;\n}\n\n.card_block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n}\n.admin_dashboard h4 {\n  color: #163873;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.dash_user_sec {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  width: 100%;\n  flex-wrap: wrap;\n}\n.card_single {\n  max-width: 280px;\n  width: 100%;\n  height: 152px;\n  justify-content: center;\n  padding: 20px;\n  border-radius: 16px !important;\n  background: #fff;\n  border: none !important;\n\n}\n.icon_sec {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.icon_sec p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  margin: auto;\n  line-height: normal;\n}\n.card_block h3 {\n  color: var(--Black, #010404);\n  text-align: right;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  margin-bottom: 0px;\n  line-height: normal;\n  letter-spacing: 0.25px;\n}\n.card_pic {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 10px;\n}\n.card_pic img {\n  max-width: 115px;\n  width: 100%;\n  min-height: 50px;\n}\n.card_pic p {\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: right;\n}\n.card_pic p span {\n  color: #38b000;\n  font-weight: 700;\n}\n.inner_banner_dash.my-3 {\n  min-height: 269px;\n  background: #ebebeb;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.inner_banner_dash p,\n.inner_side_banner p {\n  color: #b7b7b7;\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.inner_side_banner {\n  width: 100%;\n  min-height: 714px;\n  flex-shrink: 0;\n  background: #fff;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.text-p {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.text-h6 {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 700;\n  color: #010404;\n\n}\n\n.drop-down-text {\n  color: #5c677d;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14.4px;\n}\n.drop-down-text :hover :focus {\n  border-color: #5c677d;\n}\n.dash_graph {\n  background-color: #fff;\n  padding: 30px;\n}\n.th-text{\n color: #010404 !important;\n}\n/* --------------------------------------------- */\n/* ---- Super Admin: Inner Pages Data Tabel ---- */\n/* -------------------------------------------- */\n\n.tabel_page .card {\n  border-radius: 20px;\n  background: #fff;\n  padding: 15px;\n}\n\n.search_table {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n.search_table .form-control {\n  border-radius: 10px !important;\n  border: 1px solid #e5e6e7 !important;\n  background: #fff;\n  padding-left: 35px;\n  max-width: 270px;\n  width: 100%;\n  min-height: 40px;\n  color: #b8b8b8;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.search_table svg {\n  position: absolute;\n  left: 10px;\n}\n.btn_invite {\n  display: flex;\n  width: 100%;\n  max-width: 105px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  background: #163873;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.btns_sec {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.btns_sec label {\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  min-width: 50px;\n}\n\nselect.form-select {\n  padding: 7px;\n  border-radius: 10px;\n  border: 1px solid var(--Stroke, #e5e6e7);\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  min-height: 40px;\n}\n\n.filter_input span {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.filter_input .form-control {\n  border-radius: 10px;\n  border: 1px solid var(--Stroke, #e9ecef) !important;\n  background: var(--White, #fff);\n}\n.filter_btns_grp {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-start;\n}\n.select__box_block .form-select {\n  border-radius: 10px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: var(--White, #fff);\n  min-height: 40px;\n  padding: 10px;\n}\n\n.btn_online {\n  border-radius: 30px;\n  background: rgba(56, 176, 0, 0.1);\n  width: 67px;\n  height: 20px;\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.table_block .page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #163873;\n  border-color: #163873;\n}\n.table_block .page-link {\n  color: #163873;\n}\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n  border-bottom-width: 0px !important;\n  border-left-width: 0;\n  border-right-width: 0;\n}\n#dataTable_wrapper td {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  text-align: left;\n}\n#dataTable_wrapper .table thead th {\n  vertical-align: bottom;\n  border-bottom: none;\n  border-right: 1px solid #dfdfdf;\n  border-top: none;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-align: left;\n}\n#dataTable_wrapper .table thead th:last-child {\n  border-right: none !important;\n}\n.table_block .even {\n  background: transparent;\n}\n.table_input_block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  flex-wrap: wrap;\n}\n#dataTable_wrapper .dropdown-item {\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  color: var(--Black, #010404);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: flex;\n  gap: 10px;\n}\n\n.table_top_sec {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.table_handle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.btn_add_table {\n  background: #163873;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.3px;\n  color: #ffffff;\n  border: none;\n  padding: 10px 5px;\n  width: 100%;\n}\n.btn_add_table span {\n  float: left;\n  margin-left: 10px;\n}\n\n.item_search {\n  padding-left: 30px !important;\n}\n.search_icon {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n}\n.btn_fillters {\n  border: 1px solid #c4c4c4 !important;\n  border-radius: 6px;\n}\n.table_block .dataTables_wrapper div.dataTables_filter {\n  display: none;\n}\n#dataTable {\n  text-align: center;\n}\n.table td,\n.table th {\n  vertical-align: baseline;\n}\n.table_block #dataTable_length {\n  display: none;\n}\ntr.table_heading {\n  background: #163873;\n  border: 1px solid #c4c4c4;\n  color: #fff;\n}\n.table_heading th {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 1px;\n  color: #ffffff;\n}\n.even {\n  background: #f5fafc;\n}\n.btn_boost {\n  display: flex;\n  width: 80px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  border-radius: 6px;\n  background: var(--Primary, #163873);\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\ntd.verified {\n  color: #38b000 !important;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\ntd.unverified {\n  color: #ff2525 !important;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\nbutton.btn_offline {\n  width: 67px;\n  height: 20px;\n  border-radius: 30px;\n  background: rgba(128, 130, 130, 0.1);\n  color: #808282;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.btn_report {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 24px;\n  color: #fd0d0d;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n  border-radius: 30px;\n  background: rgba(253, 13, 13, 0.1);\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n}\n.btn_report_priority{\n  font-size: 10px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 24px;\n  color: #fd0d0d;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n  border-radius: 30px;\n  background: rgba(253, 13, 13, 0.1);\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n}\n.btn_pending_customer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(255, 122, 0, 0.1);\n  color: #ff7a00;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n\n.btn_accept_customer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 24px;\n  border-radius: 30px;\n  background: #38b0001a;\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.btn_accept_customer_add{\n  font-size: 10px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 24px;\n  border-radius: 30px;\n  background: #38b0001a;\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.btn_reject_customer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: #fd0d0d1a;\n  color: #fd0d0d;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.btn_approved {\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(56, 176, 0, 0.1);\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.btn_reserved {\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(253, 13, 13, 0.1);\n  color: #fd0d0d;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.table_tab_sec .nav-pills {\n  display: flex;\n  gap: 15px;\n}\n.table_tab_sec .nav-pills .nav-link {\n  border-radius: 0.25rem;\n  background: transparent;\n  color: var(--Gray-1, #808282);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.table_tab_sec .nav-pills .nav-link.active {\n  color: #163873;\n  border-bottom: 1px solid #163873;\n}\n.table_tab_sec h3 {\n  color: #163873;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 14px;\n}\n\n.btn-generate {\n  border: none;\n  display: flex;\n  width: 100%;\n  min-width: 123px !important;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  background: #163873;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.btn_export {\n  display: flex;\n  min-width: 123px !important;\n  min-height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid var(--Primary, #163873);\n  background: var(--Base, #fafafa);\n  color: var(--Primary, #163873);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.menu-dropdown {\n  min-width: 204px !important;\n  box-shadow: 0px 8px 18px 0px #0000001a !important;\n  border-radius: 10px !important;\n  border: none !important;\n}\n\n/* Profile */\n.profile__tab .nav-pills a {\n  display: flex;\n  max-width: 200px;\n  width: 100%;\n  height: 40px;\n  padding: 0px 10px;\n  align-items: center;\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.profile__tab .nav-pills .active {\n  color: #163873;\n  border-radius: 8px;\n  background: rgba(22, 56, 115, 0.1);\n}\n.profile__content {\n  max-width: 500px;\n  width: 100%;\n  padding: 0px 50px;\n}\n.profile__content .btn-primary {\n  border-radius: 10px;\n  background: #163873;\n  border: 1px solid #163873;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  min-height: 50px;\n}\n.pic_upload {\n  margin: 20px 0px;\n}\n.profile__content .form-group .form-control {\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: #e9ecef;\n  min-height: 50px;\n}\n.profile__content_label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.profile_content_inputfield {\n  border: 1px solid #e9ecef;\n  background: linear-gradient(0deg, #e9ecef, #e9ecef),\n    linear-gradient(0deg, #e9ecef, #e9ecef);\n  border-radius: 12px !important;\n  height: 50px;\n  min-width: 400px;\n  color: #010404 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19.2px !important;\n}\n\n.nav-link-profile.active {\n  border-radius: 8px;\n  height: 40px;\n  background: #1638731a;\n  color: #163873 !important;\n  font-size: 16px !important;\n  font-weight: 700;\n}\n\n.false.nav-link {\n  color: #5c677d !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19.2px !important;\n}\n\n.td-items {\n  cursor: pointer;\n}\n\n.nav-item {\n  margin-bottom: 1rem;\n}\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.dropdown-notification {\n  width: 100%;\n  min-width: 200px;\n  top: 0;\n  left: -20px !important;\n  transform: translate(-50%, 10%);\n}\n\na.dropdown-menu-header.dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 5px;\n  padding: 5px;\n}\n/* fix QA bugs manage  dimention of  dropdown-menu.show */\n.dropdown-menu.show {\n  /* width: 100%; */\n  /* min-width: 200px; */\n  top: 0;\n  left: 0;\n  transform: translate(-60%, 10%);\n  min-height:40px !important;\n  min-width: 86px !important;\n}\n\n\n/* Facility panal */\n.date_facility {\n  width: 100%;\n  max-width: 84px;\n  min-height: 40px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n  padding-left: 10px;\n  border: 1px solid rgba(233, 236, 239, 1)\n}\n\n\n.btns_sec .form-select{\n  min-width: 150px;\n}\n\n/* new css work order request */\n.property_wrap {\n  border-radius: 30px;\n  background: #fff;\n  width: 100%;\n  padding: 50px;\n}\n\n.heading_add {\n  display: flex;\n  justify-content: end;\n}\n\n.request_order {\n  max-width: unset !important;\n  margin: auto;\n  text-align: center;\n  justify-content: center;\n}\n\n.heading_content {\n  max-width: 750px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.heading_content h3 {\n  color: var(--Black, #010404);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.work__order__request_wrap ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.work__order__request_wrap ul li {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.img-click {\n  cursor: pointer;\n}\n\n.work_order_list {\n  max-width: 300px;\n  width: 100%;\n  border-bottom: 20px;\n  padding: 10px;\n}\n\n.work_order_list .form-label {\n  color: var(--grayscale-light-text-2, #acaebe);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.work_order_list .form-control {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n  border: none;\n}\n\n\n.work_order_list input:focus {\n  outline: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  \n}\n.btn_order {\n  gap: 10px;\n}\n.modal_delete_btn {\n  color: #fd0d0d;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16.8px;\n  width: 120px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #fd0d0d;\n}\n\n.btn_order .btn-primary {\n  display: flex;\n  width: 120px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background: #163873;\n  border: 1px solid #163873;\n}\n\n/* forgot password */\n.forgot-pass-div {\n  width: 100%;\n  max-width: 720px;\n  margin: auto;\n  justify-content: center;\n  text-align: center;\n  padding: 150px 0px;\n}\n\n.forgot-p {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 38px;\n  letter-spacing: 0px;\n  text-align: left;\n  color: #010404;\n}\n\n.forgot-para {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color:  #808282;\n}\n\n.btn-width {\n  max-width: 400px !important;\n}\n\n.form-control-forgot {\n  max-width: 400px;\n  height: 50px !important;\n  border-radius: 12px !important;\n  margin: auto;\n  color:  #5C677D !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19px !important;\n  letter-spacing: 0em !important;\n  text-align: left !important;\n}\n\n.back-div{\n  cursor: pointer;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0.005em;\n  text-align: left;\n  color: #000000;\n}\n\n.owner_input {\n  max-width: 400px;\n  width: 100%;\n  margin: auto;\n}\n\n.owner_input .form-control {\n  padding: 0px 45px;\n}\n\n.owner_input span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(30%, 40%);\n}\n\n.show-password {\n  position: absolute;\n  opacity: 0.7;\n  right: 0px;\n  top: 0px;\n  transform: translate(-15px, 20px);\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.upload_sec_order {\n  display: flex;\n  gap: 20px;\n}\n\n.btn-close-order {\n  min-width: 146px;\n} \n /* add css for facility panel */\n .placeholder_text::placeholder {\n  color:  #010404 !important;\n}\n.date-picker-container {\n    display: flex;\n    align-items: center;\n}\n.date-picker-icon{\n  position: relative;\n  right: 21px;\n}\n\n/* New QA bug css added */\n.customer_dropdown_tabal  {\n  width: 104px ;\n  box-shadow: 0px 8px 18px 0px #0000001A !important;\n  border: none !important;\n  border-radius: 10px !important;\n  min-height:120px\n}\n\n.border-th {\n  background-image: url('../../../images/line-table.png');\n  background-repeat: no-repeat;\n  margin-bottom: 10px !important;\n}\n\nth {\n  color:  #010404 !important;\n}\n\ntd {\n  color: #010404 !important;\n  font-weight: 500 !important;\n  font-size: 16px !important;\n}\n\n.text-colors {\n  color: #010404;\n}\n\n.img-pin {\n  width: 17px;\n  height: 17px;\n}\n\n.btns_sec_tabel {\n  min-width: 150px !important;\n}\n\n.text_red {\n  color: #FD0D0D !important;\n}\n\n.right_msg_width {\n  width: 100%;\n  max-width: 500px;\n}\n.update-upload{\n  color:#010404 !important;\n}\n.going{\n  font-size: 16px !important;\n}\n/* //add new css for customer panel */\n.date_facility_w {\n  color: #010404 !important;\n  width: 100%;\n  max-width: 84px;\n  min-height: 40px;\n  border-radius: 10px !important;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n  padding-left: 10px;\n  border:1px solid var(--Stroke, #e5e6e7) !important;\n}\n.calender_c {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px; \n}\n.active_header {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  margin-bottom: 5px; \n}\n/* add some css make for responsive seema*/\n.facility_dash {\n  display: flex;\n  gap: 0.5rem; \n}\n\n.btn_order_a {\n  display: flex;\n  justify-content: center;\n  padding-top: 3rem; \n  padding-bottom: 3rem; \n}\n@media only screen and (min-width: 310px) and (max-width: 425px) {\n.btn_order_a{\n  flex-direction: column !important;\n}.modal_delete_btn_f {\n  width:100% !important;\n}.btn_order .btn-primary {\n  width:100% !important;\n}\n}\n\n.modal_delete_btn_f{\n  color: #fd0d0d;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16.8px;\n  width: 120px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #fd0d0d;\n}\n/* new css work order request */\n\n@media only screen and (min-width: 310px) and (max-width: 768px) {\n  .property_wrap {\n    padding: 0px;\n  }.main-nav{\n    padding-bottom: 40px !important;\n  }\n}\n.modal_delete_btn_ff {\n  color: #fd0d0d;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16.8px;\n  width: 120px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #fd0d0d;\n  background:transparent !important;\n}\n.modal_cancel_btn_f {\n  display: flex;\n  width: 160px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 12px;\n  background: #163873;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n.white{\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
